// @ts-nocheck
import compact from 'lodash/compact';
import uniqueId from 'lodash/uniqueId';
import * as React from 'react';
import { classes } from './CoreDropdownOption.st.css';
const createOption = (option = null)=>({
        id: option && (option.id || option.id === 0) ? option.id : uniqueId('Option'),
        isDisabled: false,
        isSelectable: true,
        value: null,
        render: (val)=>/*#__PURE__*/ React.createElement("div", {
                className: classes.title,
                role: "presentation"
            }, val),
        ...option
    });
const escapeRegExp = (s)=>s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
const highlightRegExt = (s)=>new RegExp(`(${s.replace(/ /g, '|')})`, 'gi');
const isEven = (i)=>i % 2 === 0;
const isOdd = (i)=>i % 2 === 1;
const highlightMatches = (option, searchTerm)=>{
    const regExp = highlightRegExt(escapeRegExp(searchTerm.trim()));
    const stringArray = option.value.split(regExp);
    const f = stringArray[0] === '' ? isEven : isOdd;
    const parts = compact(stringArray).map((part, i)=>f(i) ? /*#__PURE__*/ React.createElement("mark", {
            className: classes.highlight,
            key: i
        }, part) : /*#__PURE__*/ React.createElement("span", {
            className: classes.nonHighlight,
            key: i
        }, part));
    return createOption({
        id: option.id,
        isDisabled: option.isDisabled,
        isSelectable: option.isSelectable,
        value: option.value,
        render: ()=>option.render(parts)
    });
};
export const OptionFactory = {
    create: createOption,
    createHighlighted (option, highlightValue) {
        return option.value && highlightValue ? highlightMatches(option, highlightValue) : option;
    }
};

//# sourceMappingURL=OptionFactory.js.map